import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Grid,
  Box,
  Alert
} from '@mui/material';
import { Egg } from '@mui/icons-material';

const RecordEggProduction = ({ open, onClose, onRecord }) => {
  const [formData, setFormData] = useState({
    date: '',
    eggs_collected: '',
    good_eggs: '',
    cracked_eggs: '',
    notes: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Basic validation
    if (!formData.date || !formData.eggs_collected) {
      setError('Please fill in all required fields');
      return;
    }

    if (parseInt(formData.eggs_collected) < 0) {
      setError('Invalid number of eggs');
      return;
    }

    // Create new record object
    const newRecord = {
      id: Date.now(), // Simple ID generation for demo
      date: formData.date,
      eggs_collected: parseInt(formData.eggs_collected),
      good_eggs: parseInt(formData.good_eggs) || 0,
      cracked_eggs: parseInt(formData.cracked_eggs) || 0,
      notes: formData.notes
    };

    onRecord(newRecord);
    handleClose();
  };

  const handleClose = () => {
    setFormData({
      date: '',
      eggs_collected: '',
      good_eggs: '',
      cracked_eggs: '',
      notes: ''
    });
    setError('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Egg color="primary" />
          <Typography variant="h6">Record Egg Production</Typography>
        </Box>
      </DialogTitle>
      
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <Grid container spacing={3}>
            <Grid size={12}>
              <TextField
                name="date"
                label="Date *"
                type="date"
                value={formData.date}
                onChange={handleChange}
                fullWidth
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid size={12}>
              <TextField
                name="eggs_collected"
                label="Eggs Collected *"
                type="number"
                value={formData.eggs_collected}
                onChange={handleChange}
                fullWidth
                required
                inputProps={{ min: 0 }}
              />
            </Grid>

            <Grid size={12}>
              <TextField
                name="good_eggs"
                label="Good Eggs"
                type="number"
                value={formData.good_eggs}
                onChange={handleChange}
                fullWidth
                inputProps={{ min: 0 }}
              />
            </Grid>

            <Grid size={12}>
              <TextField
                name="cracked_eggs"
                label="Cracked Eggs"
                type="number"
                value={formData.cracked_eggs}
                onChange={handleChange}
                fullWidth
                inputProps={{ min: 0 }}
              />
            </Grid>

            <Grid size={12}>
              <TextField
                name="notes"
                label="Notes"
                value={formData.notes}
                onChange={handleChange}
                fullWidth
                multiline
                rows={3}
                placeholder="Additional notes..."
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary">
            Record
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default RecordEggProduction;

